module.exports = __webpack_public_path__ + "static/media/MrAndMsAble.01ba55f7.jpg";